import { Layout, Space, Typography } from 'antd';
import styles from './Header.module.scss';
import Profile from './Profile/Profile';
import DateTime from './DateTime/DateTime';
import SiderToggler from '../Sider/Toggler/SiderToggler';
import DrawerToggler from '../Drawer/Toggler/DrawerToggler';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import { BREAKPOINTS } from '../../../utils/constants';
import { useSelector } from 'react-redux';
import ROUTES from '../../../utils/routes';
import { useLocation } from 'react-router-dom';
import MonitoringNotifications from './MonitoringNotifications/MonitoringNotifications';

const { Header: HeaderComponent } = Layout;
const { Title } = Typography;

const Header = () => {
    const { width: windowWidth } = useWindowSize();
    const location = useLocation();

    const currentPage = useSelector(state => state.global.currentPage);

    return (
        <HeaderComponent className={styles.header}>
            <Space>
                <div>{windowWidth >= BREAKPOINTS.lg ? <SiderToggler /> : <DrawerToggler />}</div>
                <Title level={3} className={styles.title}>
                    {currentPage}
                </Title>
            </Space>
            <Space className={styles.rightContainer}>
                {(location.pathname === ROUTES.EVENTS_PREMATCH.path ||
                    location.pathname === ROUTES.EVENTS_LIVE.path ||
                    location.pathname === ROUTES.BETS_MONITOR.path) && <MonitoringNotifications />}
                <DateTime />
                <Profile />
            </Space>
        </HeaderComponent>
    );
};

export default Header;
